import { render } from "./Beta.vue?vue&type=template&id=41fe97fc"
import script from "./Beta.vue?vue&type=script&lang=js"
export * from "./Beta.vue?vue&type=script&lang=js"

import exportComponent from "/home/circleci/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__